export default __webpack_public_path__ + "static/media/mobile.eba3a78d.jpg";